export enum ListRoutes {
  HOME = "/",
  ADD_PAGE = "/add-page",
  ALL = "*",
}
